module.exports = __webpack_public_path__ + "img/web1.b7609f19.png";